import { useState, useEffect } from "react";
import heroBanner from "../../assets/images/pages/driving-lessons/orange-county.jpg";
import ShellCard from "../../components/ShellCard.jsx";
import handbookEn from "../../assets/images/florida-driver-license-handbook.png";
import handbookEs from "../../assets/images/florida-driver-license-handbook-es.png";
import PackageCard from "../../components/PackageCard";

const ClasesDeManejo = () => {
    const [hoveredCardId, setHoveredCardId] = useState(null);

    useEffect(() => {
        document.title = "Clases de Manejo - Metro Traffic School";
    }, []);

    const courses = [
        {
            id: 1,
            titleLines: ["2-Horas"],
            price: "$199",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana",
            registerUrl: "https://driving.metrotrafficschool.com/book/8",
        },
        {
            id: 2,
            titleLines: ["4-Horas"],
            price: "$379",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana",
            registerUrl: "https://driving.metrotrafficschool.com/book/9",
        },
        {
            id: 3,
            titleLines: ["6-Horas"],
            price: "$539",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana\n\nExamen practico",
            registerUrl: "https://driving.metrotrafficschool.com/book/10",
        },
        {
            id: 4,
            titleLines: ["8-Horas"],
            price: "$679",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana\n\nExamen practico\n\nEntrenamiento en el Expressway",
            registerUrl: "https://driving.metrotrafficschool.com/book/11",
        },
        {
            id: 5,
            titleLines: ["10-Horas"],
            price: "$799",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana\n\nExamen practico\n\nEntrenamiento en el Expressway",
            registerUrl: "https://driving.metrotrafficschool.com/book/12",
        },
        {
            id: 6,
            titleLines: ["12-Horas"],
            price: "$899",
            description:
                "Vehículos de doble control\n\nRecogida gratuita a su domicilio\n\nClases entre semana y fines de semana\n\nExamen practico\n\nEntrenamiento en el Expressway",
            registerUrl: "https://driving.metrotrafficschool.com/book/13",
        },
    ];

    const disclaimerText =
        "Una licencia temporal o restringida es requerida bajo la ley del Estado de la Florida para poder recibir clases de manejo.";

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        background: `url(${heroBanner})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Clases de Manejo</h1>
                            <p className="banner-subheading">
                                Ofrecemos lecciones de conducción en los siguientes condados
                                <br />
                                Miami-Dade, Broward, Palm Beach, Orange, Osceola, Lake, y
                                Seminole
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="online-traffic-school-page container pt-5">
                <div className="row g-4">
                    {courses.map((c) => (
                        <div className="col-12 col-sm-6 col-lg-4" key={c.id}>
                            <PackageCard
                                pkg={{
                                    ...c,
                                    registerLink: c.registerUrl,
                                    description: (
                                        <div style={{ whiteSpace: "pre-line" }}>
                                            {c.description}
                                        </div>
                                    ),
                                }}
                                hoveredCardId={hoveredCardId}
                                setHoveredCardId={setHoveredCardId}
                                registerText="REGISTRARME"
                            />
                        </div>
                    ))}
                </div>

                <div className="row py-5">
                    <div className="col-12">
                        <p className="fst-italic text-center px-4 fw-bold mb-0">{disclaimerText}</p>
                    </div>
                </div>
            </section>

            <section className="container pb-5">
                <div className="row">
                    <div className="col-12">
                        <ShellCard>
                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <h5 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                                            ¿Por qué Metro Traffic School?
                                        </h5>
                                        <p className="lh-lg" style={{ color: "#fff" }}>
                                            CON EL FIN DE ALCANZAR NUESTRO META DE CREAR UN MUNDO MAS
                                            SEGURO, NOSOTROS CREEMOS QUE EL PRIMER PASO PARA LOGRARLO
                                            ES DESARROLLANDO BUENOS HABITOS DE MANEJO DESDE EL
                                            COMIENZO. El compromiso de Metro Driving School de crear
                                            buenos conductores comienza por proveer las mejores clases
                                            de manejo disponibles. Todos nuestros instructores tienen
                                            años de experiencia y han pasado por un entrenamiento
                                            riguroso para obtener sus certificaciones. Nuestros
                                            vehículos son todos modelos nuevos, con doble control y
                                            son, a su vez, inspeccionados continuamente para asegurar
                                            que cumplen nuestras normas de excelencia.
                                        </p>
                                        <p className="lh-lg" style={{ color: "#fff" }}>
                                            Al completar las clases de Metro, no solo tendrás la
                                            oportunidad de tomar el examen práctico con el mismo
                                            vehículo, sino también, puedes calificar para un descuento
                                            para el seguro de auto. Metro Driving School es reconocido
                                            a nivel estatal por el valor y compromiso que le damos a
                                            la seguridad. Por lo tanto, al culminar uno de nuestros
                                            programas, la mayoría de grandes aseguradoras le proveerán
                                            una mejor oferta para su pago mensual.
                                        </p>
                                        <p className="lh-lg" style={{ color: "#fff" }}>
                                            Nosotros apoyamos cada programa en el raro caso de que
                                            usted no quede completamente satisfecho con Metro Traffic
                                            School, por favor llámenos para asegurarnos de que cada
                                            futura experiencia no sea menos que excelente. Nuestro
                                            dedicado grupo de servicio al cliente le apoyara y estará
                                            con usted a lo largo del camino; no solo para asegurarse
                                            de que usted obtenga la experiencia de manejo que merece,
                                            sino también, para que esté más cerca de pasar el examen
                                            práctico en su primer intento y convertirse en un
                                            conductor sobresaliente.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </ShellCard>
                    </div>
                </div>
            </section>

            <section className="container pb-5">
                <div className="row">
                    <div className="col-12 d-flex flex-column align-items-start">
                        <a
                            href="/clases-de-manejo/informacion"
                            className="btn metro-btn-primary fw-bold px-4 py-2 mb-5"
                        >
                            Más Información
                        </a>
                        <div className="d-flex justify-content-left gap-5 flex-wrap">
                            <a
                                href="https://www.flhsmv.gov/pdf/handbooks/englishdriverhandbook.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={handbookEn}
                                    alt="Florida Driver License Handbook"
                                    className="img-fluid"
                                    style={{ maxWidth: "250px" }}
                                />
                            </a>
                            <a
                                href="https://www.flhsmv.gov/pdf/handbooks/spanishdriverhandbook.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={handbookEs}
                                    alt="Manual Oficial Para Licencias de Conducir de Florida"
                                    className="img-fluid"
                                    style={{ maxWidth: "250px" }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container" style={{ marginBottom: "32px" }}>
                <div className="row text-white">
                    <p>
                        Superb Customer Service
                    </p>
                    <p>
                        At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                    </p>
                </div>
            </div>
        </>
    );
};

export default ClasesDeManejo;
